export default __webpack_public_path__ + "static/6671products-576e7b26b12182b6f47a184ab8b138dc.jpg";